import { defineMessages } from 'react-intl'

const scope = 'modules.vendor.components.creditCardProviderSelect'

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Please select an option',
  },
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Credit card provider',
  },
  createNewOption: {
    id: `${scope}.createNewOption`,
    defaultMessage: 'Create new',
  },
  manageProvidersOption: {
    id: `${scope}.manageProvidersOption`,
    defaultMessage: 'Manage providers',
  },
  newProviderNameLabel: {
    id: `${scope}.newProviderNameLabel`,
    defaultMessage: 'New provider name',
  },
  newProviderNamePlaceholder: {
    id: `${scope}.newProviderNamePlaceholder`,
    defaultMessage: 'Enter provider name',
  },
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'Create',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  createErrorToastTitle: {
    id: `${scope}.createErrorToastTitle`,
    defaultMessage: 'Error',
  },
  createErrorToastMessage: {
    id: `${scope}.createErrorToastMessage`,
    defaultMessage: 'Unable to create the credit card provider.',
  },
})
